import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './FlashMessages.scss';

export default function Message(props) {
    const { indicator, content } = props;

    const flashStyle = indicator.split('.').reverse()[0];

    return (
        <div data-flash={indicator} className={styles[flashStyle]}>
            <div className={styles.content}>
                {content}
            </div>
        </div>
    );
}

Message.displayName = displayName('FlashMessages/Message');

Message.propTypes = {
    indicator: PropTypes.string,
    content: PropTypes.node,
};

Message.defaultProps = {
    indicator: '',
    content: null,
};
